import React from "react";
import { EnvironmentOutlined, GlobalOutlined, ShopOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Routes from "src/constants/routes";

import LanguageSelect from "../LanguageSelect";
import {
  AddBusinessButton,
  AuthWrapper,
  HeaderStyled,
  IconStyled,
  LeftZone,
  LogoImage,
  SelectGroup,
  RegionSelectStyled,
  TopRow,
  AddBusinessButtonTextStyled,
} from "./styled";
import AuthContainer from "./auth-container/AuthContainer";

const AppHeader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <HeaderStyled>
      <TopRow>
        <Link to={Routes.home}>
          <LeftZone>
            <LogoImage />
          </LeftZone>
        </Link>

        <AuthWrapper>
          <AddBusinessButton to={import.meta.env.VITE_BUSINESS_SITE_URL} target="_blank">
            <ShopOutlined />
            <AddBusinessButtonTextStyled>{t("common.addService")}</AddBusinessButtonTextStyled>
          </AddBusinessButton>
          <SelectGroup>
            <IconStyled>
              <GlobalOutlined />
            </IconStyled>
            <LanguageSelect />
            <IconStyled>
              <EnvironmentOutlined />
            </IconStyled>
            <RegionSelectStyled defaultValue="ny">
              <option value="ny">New York</option>
              <option value="la">Los Angeles</option>
              <option value="moscow">Moscow</option>
            </RegionSelectStyled>
          </SelectGroup>
          <AuthContainer />
        </AuthWrapper>
      </TopRow>
    </HeaderStyled>
  );
};

export default AppHeader;
